import { isAxiosError } from "axios";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import StarDisplay from "../../../components/StarDisplay";

const coloresEstados = [
  { id: 1, color: "bg-success" },
  { id: 2, color: "bg-primary" },
  { id: 3, color: "bg-danger" },
];

export const getColorEstado = (id) => {
  return coloresEstados.filter((col) => {
    if (col.id === id) {
      return col.color;
    }
  });
};

export const getPodadores = async (podadores, setPodadores) => {
  setPodadores({ ...podadores, loading: true });
  let response = await axios().get("podadores");

  if (!isAxiosError(response)) {
    const { data, error } = response.data;
    if (data && !error) {
      setPodadores({ ...podadores, data: data, loading: false });
      toast.success("Podadores cargados", toastOptions);
    }

    if (!data && error) {
      setPodadores({ ...podadores, error: error, loading: false });
      toast.error(error, toastOptions);
    }
  } else {
    setPodadores({ ...podadores, loading: false, error: "Hubo un error inesperado" });
  }
};

export const dataTable = (data) => {
  const columns = [
    // { field: "id", headerName: "#", flex: 0.5, minWidth: 50, hide:true },
    {
      field: "estado_badge",
      headerName: "Estado",
      renderCell: (p) => {
        let col = getColorEstado(p.row.estado.id);
        return (
          <div className="d-flex justify-content-center w-100">
            <span className={`badge ${col[0].color}`}>{p.value}</span>
          </div>
        );
      },
      minWidth: 90,
      flex: 1.2,
    },

    {
      field: "nombre",
      headerName: "Nombre",
      minWidth: 250,
      flex: 2,
    },
    {
      field: "telefono",
      headerName: "Telefono",
      minWidth: 110,
      flex: 1,
    },
    {
      field: "dni",
      headerName: "DNI",
      minWidth: 90,
      flex: 1,
    },
    {
      //   field: "nombre",
      headerName: "Puntuación",
      headerClassName: "custom-header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <p className="d-flex gap-1 align-items-end m-0">
            <StarDisplay rating={params?.row?.promedio} />
            <span
              style={{ fontSize: "12px", lineHeight: "16px" }}
            >{`(${params?.row?.cant}) `}</span>
          </p>
        );
      },
    },
    {
      field: "info",
      headerName: "Información",
      minWidth: 220,
      flex: 2,
    },
    {
      field: "boton",
      headerName: "Acciones",
      renderCell: (p) => {
        return (
          <Link className="btn btn-primary btn-sm" to={"/podador/" + p.row.id}>
            Ver podador
          </Link>
        );
      },
      minWidth: 120,
      flex: 1,
    },
  ];

  const rows = data.map((d) => {
    return {
      id: d.id,
      estado_badge: d.estado.estado,
      estado: d.estado,
      dni: d.dni,
      nombre: d.nombre,
      telefono: d.telefono,
      info: d.info ?? "",
      boton: d.id,
      cant: d?.cant_puntuacion,
      promedio: d?.promedio,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      d.id?.toString().toLowerCase().includes(value) ||
      d.estado_badge?.toLowerCase().includes(value) ||
      d.nombre?.toLowerCase().includes(value) ||
      d.dni?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
